import CalculateCartService from "../services/CalculateCartService";

/**
 * Performs reduction logic for PPI on MAPI calls cart and sets checkout params
 * @param rootGetters
 * @param dispatch
 * @returns {{Promise}}
 */
const processPpiReductionsMAPI = async (rootGetters, dispatch): Promise<void | Error> => {
  try {
    //We will post reductions to calculate cart only the first time one was found AND getReductions returned a valid reduction
    if (!rootGetters["cart/isPpiMAPIReductionApplied"] && rootGetters["cart/getFirstreductionId"]) {
      await addReductionToMAPICart(rootGetters, dispatch);
    }
    return Promise.resolve();
  } catch (e) {
    return Promise.reject(e);
  }
};

const addReductionToMAPICart = async (rootGetters, dispatch): Promise<void> => {
  //Apply last reduction as promo code
  await dispatch("cart/validateCart", { promoCode: rootGetters["cart/getFirstreductionId"] }, { root: true });
  //Only set reduction applied when there's at least one
  if (rootGetters["cart/getPpiReductions"].length) dispatch("cart/applyMAPIPpiReduction", {}, { root: true });

  //Set checkout parms
  const params = {
    subtotalAmount: rootGetters["cart/getSubTotal"](rootGetters["cart/getAvailableCartItems"]),
    tip: rootGetters["cart/getTipValue"],
    tax: rootGetters["cart/getTaxValue"](),
    fee: rootGetters["cart/getFeeValue"](rootGetters["cart/getDiscountedSubTotal"]),
    amount: rootGetters["cart/getFinalPrice"](rootGetters["cart/getAvailableCartItems"]),
    promoInfo: Object.assign({}, rootGetters["cart/getPromoInfo"]),
    cartItems: [].concat(rootGetters["cart/getAvailableCartItems"])
  };
  dispatch("cart/setCheckoutParams", params, { root: true });
};

/**
 * Calls cart directly for PPI on OAPI and sets checkout params
 * @param getters
 * @param rootGetters
 * @param dispatch
 * @returns {{Promise}}
 */
const processPpiReductionsOAPI = async (getters, rootGetters, dispatch): Promise<void | Error> => {
  try {
    const reqBody = getters.getCartToApplyPromo("");

    await CalculateCartService.get(
      getters,
      rootGetters,
      dispatch,
      reqBody,
      rootGetters["venue/getActiveVenue"],
      rootGetters["vendor/getActiveVendor"].id,
      ""
    );

    const params = {
      subtotalAmount: rootGetters["cart/getSubTotal"](rootGetters["cart/getAvailableCartItems"]),
      tip: rootGetters["cart/getTipValue"],
      tax: rootGetters["cart/getTaxValue"](),
      fee: rootGetters["cart/getFeeValue"](rootGetters["cart/getDiscountedSubTotal"]),
      amount: rootGetters["cart/getFinalPrice"](rootGetters["cart/getAvailableCartItems"]),
      roundUpAmount: rootGetters["cart/getRoundUpForCharityAmount"],
      roundUpForCharity: rootGetters["cart/getRoundUpForCharity"],
      promoInfo: Object.assign({}, rootGetters["cart/getPromoInfo"]),
      cartItems: [].concat(rootGetters["cart/getAvailableCartItems"]),
      OAPIDiscounts: rootGetters["cart/getOAPITotalDiscounts"],
      OAPIFeesDetail: rootGetters["cart/getOAPIFeesDetail"]
    };

    dispatch("cart/setCheckoutParams", params, { root: true });

    return Promise.resolve();
  } catch (e) {
    return Promise.reject(e);
  }
};

/**
 * Performs specific MAPI logic when removing a reduction
 * @param rootGetters
 * @param dispatch
 */
const removePpiReductionsMAPI = async (rootGetters, dispatch): Promise<void> => {
  //reduction previously applied or first ppi card now has a reduction
  if (rootGetters["cart/isPpiMAPIReductionApplied"] || rootGetters["cart/getFirstreductionId"]) {
    dispatch("removeMAPIPpiReduction");
    dispatch("cart/clearDiscount", {}, { root: true });

    addReductionToMAPICart(rootGetters, dispatch);
  }
};

export { processPpiReductionsMAPI, processPpiReductionsOAPI, removePpiReductionsMAPI };
